import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

export default function ErrorOverlay() {
  return (
    <Grid
      container
      justifyContent={"center"}
      alignItems={"center"}
      style={{ height: 200 }}
    >
      <Typography fontWeight={"bold"} fontStyle={"italic"} color={"primary"}>
        Something Went Wrong!
      </Typography>
    </Grid>
  );
}
